import { Box, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Redirect } from "react-router-dom";
import { useChat } from "../../../Providers/Data/ChatProvider.jsx";
import ChatList from "./components/ChatList.jsx";
import MessagingBox from "./components/MessagingBox.jsx";
import UserDetails from "./components/UserDetails.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    marginTop: 10,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: theme.palette.borderColor.main,
  },
}));

/** */
const Chat = () => {
  const classes = useStyles();
  const { userInfo } = useBaseData();
  const { selectedEmployee } = useChat();

  if (!userInfo.isChatAvailable) {
    return <Redirect to="/" />;
  }

  return (
    <Paper className={classes.root} variant="outlined">
      <Box display="flex" height="80vh">
        <ChatList />
        {!!selectedEmployee && <MessagingBox />}
        {!!selectedEmployee && <UserDetails />}
      </Box>
    </Paper>
  );
};

export default Chat;
